import React, { useState } from "react";
import { CheckOutlined, CopyOutlined } from "@ant-design/icons";

const CopyToClipboard: React.FC<{ content: string }> = ({ content }) => {
  const [copied, setCopied] = useState(false);

  if (!content) return <></>;
  
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(content);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  return copied ? <CheckOutlined /> : <CopyOutlined title="Copy" onClick={handleCopy} />;
};

export default CopyToClipboard;